<template>
  <v-container fluid> 
      <template>

<!-- main table -->
  <v-data-table   
    :headers="headers"
    :search="search"
    :items="users"   
     class="elevation-0 my_btn bg-main"
    :footer-props="{
          'items-per-page-text':'عدد العناصر',
            'next-icon':'$prev',
            'prev-icon':'$next', 
          }"
  >
    <template v-slot:top>
      <v-toolbar
        flat class="bg-main"
      >
      <!-- header -->
        <v-toolbar-title >المستخدمين</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <!-- search -->
         <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="بحث"
            single-line
            hide-details 
        ></v-text-field>
         <v-spacer></v-spacer>
        <!-- add and delete dialog -->
        <v-dialog 
          v-model="dialog"
          max-width="700px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary" 
              class="mb-2"
              v-bind="attrs"
              v-on="on"
              @click="checkPermissions('user-add')"
            >أضافة<v-icon>mdi-plus</v-icon>  
            </v-btn> 
            
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>
            <!-- dialog add and edit  -->
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                        dir="ltr"
                        cols="12"
                        sm="6"
                        md="6"
                    >
                        <v-autocomplete  
                        outlined
                        v-model="editedItem.employee_id" 
                        :items="employees_n"   
                        item-text="name"
                        item-value="id"
                        label="المستحدم"   >
                        </v-autocomplete>
                    </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-text-field
                      v-model="editedItem.email"
                      :rules="rules.email"
                      required
                      type="email"
                      label="الايميل"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-text-field
                      v-model="editedItem.username"
                      :rules="rules.username"
                      required 
                      label="اسم المستخدم"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="editedItem.password"
                      :rules="rules.password"
                      required 
                      label="الرمز"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="editedItem.password_confirmation"
                      :rules="rules.password"
                      required 
                      label="اعد كتابة الرمز"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-col dir="ltr" cols="12" sm="6" md="4">
                    <v-autocomplete
                      reverse
                      outlined
                      v-model="editedItem.role_id"
                      :items="roles"
                      item-text="name"
                      item-value="id"
                      label="صلاحيات"
                    ></v-autocomplete>
                  </v-col>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="close" > إلغاء </v-btn>
              <v-btn color="green"    :disabled="!formIsValid"  type="submit"  @click="save" > حفظ </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog  v-model="dialogDelete" max-width="500px">
          <v-card>
            <!-- delete dialog -->
            <v-card-title text class="text-h6">هل تريد حذف العنصر بشكل نهائي</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="closeDelete">الغاء</v-btn>
              <v-btn color="green darken-1" text @click="deleteItemConfirm">موافق</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <!-- actions of table -->
    <template  v-slot:[`item.operation`]="{item}" >
      <v-icon color="" class="mr-2" @click="editItem(item)" > mdi-pencil </v-icon>
      <v-icon color="red" @click="deleteItem(item)" > mdi-delete </v-icon> 
    </template>
    <template v-slot:no-data>
      <v-card
      loading
      ><v-btn > انتظر..... </v-btn>
      </v-card>
    </template>
  </v-data-table>
 </template>
</v-container>

</template>
<script>
import tools from '@/plugins/tools'
import { mapActions, mapGetters } from 'vuex' 
  export default {
    name:'usersCard',
    data: () => ({  
      dialog: false,
      dialogDelete: false,   
      search:'', 
      re_password:'',
      rules: { 
          name: [val => (val || '').length > 0 || 'ادخل الاسم '],  
          email: [val => (val || '').length > 0 || 'ادخل الاميل '],  
          username: [val => /^[a-zA-Z]+$/.test((val || '')) || 'اسم المستخدم غير صالح'],  
          password: [val => (val || '').length > 6  || 'يجب ان يحتوي اكثر من 7 مراتب'],  
        }, 
      headers: [
        { text: 'الاسم',value: 'name',align:'start',sortable: false,},  
        { text: 'الايميل',value: 'email',align:'start',sortable: false,},  
        { text: 'اسم المستخدم',value: 'username',align:'start',sortable: false,},  
        { text: 'الصلاحيات', value: 'role.name',align:'end', sortable: false },
        { text: 'العمليات', value: 'operation',align:'end', sortable: false },
      ], 
      editedIndex: -1,
      editedItem: {
        name: '', 
        email:'',
        username:'',
        password:'',

      },
      defaultItem: {
        name: '', 
        email:'',
        username:'', 
        password:'',
      }
    }),

    computed: {
      ...mapGetters(['users','roles','employees_n']),
      formTitle () {
        return this.editedIndex === -1 ? 'أضافة جديد' : 'تعديل'
      },
      formIsValid () {
        return (
             Boolean(this.editedItem.employee_id ) 
          && Boolean(this.editedItem.username)
          && Boolean(this.editedItem.role_id)
          && Boolean(this.editedItem.password )
          && Boolean(this.editedItem.password_confirmation == this.editedItem.password )
        )
        }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {  
        this.f_roleNames()
        this.f_user()
        this.f_employees_n()
    }, 
    

    methods: {
      ...mapActions(['f_user','f_roleNames','f_employees_n','deleteCard','addCard','updateCard']),
      checkPermissions(per){tools.checkPermissions(per) },
      editItem (item) {
        this.checkPermissions('user-update')

        this.editedIndex = this.users.indexOf(item)
        this.editedItem = Object.assign({}, item) 
        this.editedItem.role_id=item.role.name
        this.dialog = true
      },

      deleteItem (item) {
        this.checkPermissions('user-delete')
        this.editedIndex = this.users.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      }, 
      deleteItemConfirm () {  
        let card=[]; card.type="user"
        card.id=this.users[this.editedIndex].id
        this.deleteCard(card) 
        this.closeDelete()  
      },

      close () {
        this.dialog = false 
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {//save dialog add and edit
        //update item 
          let paramsToUpdate={} 
          paramsToUpdate.name= this.editedItem.name  
          paramsToUpdate.email= this.editedItem.email  
          paramsToUpdate.email= this.editedItem.username  
          paramsToUpdate.password= this.editedItem.password  

        if (this.editedIndex > -1) { 
          let card=[];card.type='user'
          card.id=this.users[this.editedIndex].id
          card.data=paramsToUpdate;
          
          console.log(paramsToUpdate)
          this.updateCard(card)  
        } else {
          //add new item   
          let card=[];card.type='user' 
          card.data=this.editedItem; 

          this.addCard(card)  
        }
        this.close()
      },

    }, 
  }
</script>
